
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/sailthru",
      function () {
        return require("private-next-pages/destinations/sailthru.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/sailthru"])
      });
    }
  